module.exports = __webpack_public_path__ + "96444c22cba84ae9674aa73f745dddbc.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/photo-backgrounds/places-in-the-house/House3.jpg
// module id = 3554
// module chunks = 0